'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavItem = function NavItem(_ref) {
  var item = _ref.item,
      active = _ref.active,
      nested = _ref.nested,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'a',
    {
      onClick: onClick,
      href: item.url,
      className: 'list-group-item clickable' + (active ? ' active' : '') + (nested ? ' level-two' : '') },
    item.svg ? _react2.default.createElement(_Icon2.default, { name: item.svg }) : item.glyphicon ? _react2.default.createElement('i', { className: 'fa fa-' + item.glyphicon }) : item.iconUrl ? _react2.default.createElement('img', { src: item.iconUrl }) : null,
    item.text,
    item.subItems && _react2.default.createElement('i', { className: 'fa fa-xl fa-angle-' + (active ? 'up' : 'down') + ' pull-right' })
  );
};

NavItem.propTypes = {
  item: _propTypes2.default.object,
  active: _propTypes2.default.bool,
  nested: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

exports.default = NavItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/Header/NavItem.js
// module id = 220
// module chunks = 0